import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {selectChapterRead} from '../../../store/reducers';
import {breakpoints, mobileMediaQuery, webMediaQuery} from '../../../styles';
import ComicProgressBar from '../ComicProgressBar';
//import ChapterProgressBar from '../ComicProgressBar';

const ComicBigItem = props => {
    const _onPress = () => {
        props.onPress(props.comic);
    };

    return (
        <Container
            onPress={_onPress}
            width={props.width}
            to={`/comics/${props.comic.friendlyName}`}
        >
            <Image
                src={`${props.comic.baseUrl}${props.comic.cover}`}
                height={props.height}
            />
            <ComicDataView comic={props.comic} size={props.size} />
        </Container>
    );
};

const Container = styled(Link)`
    display: flex;
    flex-direction: row;
    background-color: #211921;
    width: 100%;
    height: 310px;
    cursor: pointer;
    color: transparent;
    text-decoration: none;

    @media screen and (max-width: ${breakpoints.md}px) {
        height: 440px;
    }

    ${mobileMediaQuery} {
        height: 210px;
    }

    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
    &:hover {
        ${webMediaQuery} {
            transform: scale(1.05);
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
    }
`;

const Image = styled.img`
    height: ${props => props.height}px;
    aspect-ratio: 0.714;
`;

export default ComicBigItem;

const ComicDataView = ({comic, size}) => {
    const {t} = useTranslation();
    const progress = useSelector(state =>
        comic.chapters.map(chapter => selectChapterRead(state, chapter.id)),
    ).reduce((acc, val) => (val ? acc + 1 : acc), 0);

    let text;
    if (progress === 0) {
        text = t('comics.chapterRead0');
    } else if (progress === 1) {
        text = t('comics.chapterRead1');
    } else {
        text = t('comics.chapterRead2').replace('{count}', progress.toString());
    }

    return (
        <DataContainer size={size}>
            <BorderedTitle>{comic.show.toUpperCase()}</BorderedTitle>
            <TitleText size={size}>{comic.title}</TitleText>
            <Spacer />
            <ReadText size={size}>{text}</ReadText>
            <ComicProgressBar comic={comic} size={size} />

            <ButtonRead>{t('comics.readNow')}</ButtonRead>
        </DataContainer>
    );
};

const DataContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px;
    flex: 1;
    ${mobileMediaQuery} {
        padding: 16px;
    }
`;

const TitleText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 20px;
    color: white;
    text-transform: uppercase;
    margin-top: 4px;

    ${mobileMediaQuery} {
        font-size: 14px;
        max-width: calc(100% - 32px);
    }
`;

const Spacer = styled.div`
    flex: 1;
    max-height: 45px;
`;

const ReadText = styled.div`
    font-family: AvenirNextRoundedStd;
    font-size: 16px;
    color: white;
    margin-bottom: 4px;
`;

const ButtonRead = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: white;
    padding: 8px 16px;
    background-color: rgba(255, 255, 255, 0.18);
    border-radius: 16px;
    overflow: hidden;
    text-transform: uppercase;
    align-self: baseline;
    margin-top: 16px;
`;

const BorderedTitle = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 16px;
    height: 900;
    text-shadow: 1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white,
        -1px -1px 0 white;
    color: #211921;
    text-transform: uppercase;

    ${mobileMediaQuery} {
        font-size: 14px;
    }
`;
